import React from 'react';
import PropTypes from 'prop-types';

import InvoiceDetails from '../InvoiceDetails';
import InvoiceCardMobile from '../InvoiceCardMobile';
import ClaimFrame from '../ClaimFrame';

const ClaimMobileView = ({ claim }) => (
  <ClaimFrame claim={claim}>
    {claim.invoices.map((invoice) => (
      <InvoiceCardMobile key={invoice.rowId} invoice={invoice} invoiceId={invoice.rowId}>
        <InvoiceDetails data={invoice} />
      </InvoiceCardMobile>
    ))}
  </ClaimFrame>
);

ClaimMobileView.propTypes = {
  claim: PropTypes.shape({
    claimNumber: PropTypes.string,
    claimDate: PropTypes.string,
    expert: PropTypes.string,
    claimType: PropTypes.string,
    invoices: PropTypes.arrayOf(PropTypes.shape({})),
    isCasco: PropTypes.bool,
  }).isRequired,
};

export default ClaimMobileView;
